<template>
  <div class="text-center">
    <v-dialog v-model="dialog" width="300">
      <v-card v-if="error">
        <v-card-title primary-title>{{ $t("company.join.title") }}</v-card-title>
        <v-card-text>{{ error }}.</v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="redirectHome">{{ $t("common.close") }}</v-btn>
        </v-card-actions>
      </v-card>
      <v-card v-else-if="!company">
        <v-card-title primary-title>{{ $t("company.join.join_company") }}</v-card-title>
        <v-card-text>{{ $t("common.wait") }}</v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-progress-circular indeterminate color="primary"></v-progress-circular>
        </v-card-actions>
      </v-card>
      <v-card v-else>
        <v-card-title primary-title>{{ $t("company.join.join_company") }}</v-card-title>
        <v-card-text>{{ $t("company.join.success", { companyName: company.name }) }}.</v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="exitSuccess">{{ $t("common.continue") }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import functions from "@/firebase/functions";

export default {
  data() {
    return {
      company: null,
      error: null,
    };
  },
  methods: {
    redirectHome() {
      this.dialog = false;
      this.$router.push({
        name: "Home",
      });
    },
    exitSuccess() {
      this.dialog = false;
      this.$router.push({ name: "Company" });
    },
  },
  created() {
    this.dialog = true;
    if (this.$route.query.companyId) {
      const { companyId } = this.$route.query;
      console.log(this.$route.query);
      functions
        .joinCompany({ companyId })
        .then((result) => {
          console.log(result);
          this.company = result.data;
          this.$store.dispatch("getCompanies", this.$store.state.firUser);
        })
        .catch((error) => {
          const { message } = error;
          console.log(error);
          console.log(message);
          this.error = message;
        });
    } else {
      console.log("no company to join :(");
    }
  },
};
</script>
